import DOMPurify from 'dompurify';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import { isBrowser } from '../../helpers/is-browser';
import {
  IImageWrapperFile,
  IImageWrapperSvg,
} from '../../queries/fragments/svg';

interface ImageWrapperProps {
  gatsbyImageData: IGatsbyImageData | null;
  alt: string;
  file: IImageWrapperFile;
  svg: IImageWrapperSvg;
  className?: string;
  imgClassName?: string;
}

// Render inline SVG with fallback non-svg images
const ImageWrapper = ({
  svg,
  gatsbyImageData,
  file,
  alt,
  className,
  imgClassName,
}: ImageWrapperProps) => {
  if (file?.contentType === 'image/svg+xml' || file?.url?.endsWith('.svg')) {
    if (svg && svg.content) {
      return (
        <div className={className}>
          <img
            className={imgClassName ?? ''}
            src={file?.url + '?q=75'}
            alt={alt}
          />
        </div>
      );
    }

    // SVGs that can/should not be inlined
    return (
      <img className={className ?? ''} src={file?.url + '?fm=avif'} alt={alt} />
    );
  }

  // Non SVG images
  return gatsbyImageData ? (
    <GatsbyImage
      className={className ?? ''}
      imgClassName={imgClassName ?? ''}
      image={gatsbyImageData}
      alt={alt}
    />
  ) : (
    <></>
  );
};

export default ImageWrapper;
